import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BankStatementTransaction } from "@/types/bank-statement";
import { AlertCircle } from "lucide-react";

interface DeleteTransactionModalProps {
  isOpen: boolean;
  onClose: () => void;
  transaction: BankStatementTransaction | null;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export function DeleteTransactionModal({ isOpen, onClose, transaction, onConfirm, isDeleting }: DeleteTransactionModalProps) {
  if (!transaction) return null;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[425px] bg-[#15203c] border-gray-700 text-white">
        <DialogHeader className="flex flex-row items-center gap-3">
          <AlertCircle className="w-6 h-6 text-red-500" />
          <DialogTitle className="text-xl font-bold m-0">Aviso</DialogTitle>
        </DialogHeader>
        
        <div className="py-4">
          <p className="text-sm text-gray-300">
            A exclusão desta operação é permanente e <strong>não poderá ser desfeita</strong>.
          </p>
          <div className="bg-[#0c1427] p-3 rounded-md mt-4 border border-gray-700">
            <p className="text-sm font-medium">{transaction.description || "Transação sem descrição"}</p>
            <p className="text-xs text-gray-400 mt-1">{transaction.paymentDate} - R$ {transaction.amount.toFixed(2)}</p>
          </div>
          <p className="text-sm text-gray-300 mt-4">
            Tem certeza de que deseja continuar?
          </p>
        </div>

        <DialogFooter className="gap-2 sm:gap-0">
          <Button onClick={onClose} variant="outline" className="border-gray-600 text-white hover:bg-gray-700" disabled={isDeleting}>
            Cancelar
          </Button>
          <Button 
            onClick={onConfirm} 
            variant="destructive"
            className="bg-red-600 hover:bg-red-700 text-white"
            disabled={isDeleting}
          >
            {isDeleting ? "Excluindo..." : "Sim, excluir operação"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
